import PropTypes from 'prop-types';
import React from 'react';
import ConfirmDeleteDialog from './ConfirmDeleteDialog';

const DeleteFolderDialog = ({ open, onClose, onConfirm, deleting }) => (
  <ConfirmDeleteDialog
    id="delete-section-modal"
    data-testid="delete-section-modal"
    title="Delete this section?"
    message="All pages in this section will be permanently deleted."
    open={open}
    onClose={onClose}
    onConfirm={onConfirm}
    deleting={deleting}
  />
);

DeleteFolderDialog.propTypes = {
  deleting: PropTypes.bool.isRequired,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

export default DeleteFolderDialog;
